import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { H2 } from 'components/core/Typography';
import { AccordionItem } from 'components/search/Accordion';

import './accordion.scss';

export function Accordion({
	className,
	accordionTitle,
	content = [],
	isFAQ,
	preserve = false,
}) {
	let faqSchema = {};
	if (isFAQ) {
		faqSchema = {
			'@context': 'https://schema.org',
			'@type': 'FAQPage',
			mainEntity: content.map((faq) => ({
				'@type': 'Question',
				name: faq.title,
				acceptedAnswer: {
					'@type': 'Answer',
					text: faq.copy,
				},
			})),
		};

		faqSchema = JSON.stringify(faqSchema);
	}

	return (
		<div className={classnames(className, 'accordion')}>
			<H2
				size="medium"
				className="accordion-title"
			>
				{accordionTitle}
			</H2>
			<div>
				{content.map(({ title, copy, link }) => (
					<AccordionItem
						title={title}
						copy={copy}
						link={link}
						key={title}
						isFAQ={isFAQ}
						preserve={preserve}
					/>
				))}
			</div>
			{!isEmpty(faqSchema) && (
				<script
					key="schema"
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: faqSchema,
					}}
				/>
			)}
		</div>
	);
}

Accordion.propTypes = {
	className: PropTypes.string,
	accordionTitle: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.object),
	isFAQ: PropTypes.bool,
	preserve: PropTypes.bool,
};

export default Accordion;
